import { create } from 'zustand';
import { RequestStatus } from '@/shared/model/requestStatus';
import { userChatProfileService } from '../api/userChatProfileService';
import type { UserChatCompanionData, UserChatCompanionActions } from './types';

const initialData: UserChatCompanionData = {
    profile: null,
    status: RequestStatus.Idle,
    error: null
};

/** Хранит контакт собеседника с защитой от переключения диалога */
export const createUserChatCompanionStore = () => {
    let revision = 0;

    return create<UserChatCompanionData & UserChatCompanionActions>((set) => ({
        ...initialData,

        load: async (id, role) => {
            const current = ++revision;

            set({
                ...initialData,
                status: RequestStatus.Loading
            });

            try {
                const profile = await userChatProfileService.getCompanionProfile(id, role);

                if (current === revision) set({
                    profile,
                    status: RequestStatus.Success
                });
            } catch {
                if (current === revision) set({
                    error: 'Не удалось найти профиль собеседника',
                    status: RequestStatus.Error
                });
            }
        },

        reset: () => {
            revision += 1;
            set(initialData);
        },
    }));
};
